// extracted by mini-css-extract-plugin
module.exports = {"logoTitle":"LogoTitle_logoTitle__1E-vC","title":"LogoTitle_title__38AW-","logo":"LogoTitle_logo__31dMV"};